module.exports = __webpack_public_path__ + "img/browse-vehicles-background-infiniti.e5a7cef4.png";